<!--
 * @Description:  课程栏目banner处的栏目名称
 * @version:
 * @Author: 李云飞
 * @Date: 2020-05-18 19:36:14
 * @LastEditors: 李云飞
 * @LastEditTime: 2020-10-22 10:41:33
-->

<template>
  <div class="column-name">
    <p class="column-en">
      {{ enName }}
    </p>
    <p class="column-cn">
      {{ cnName }}
    </p>
  </div>
</template>

<script>

export default {
  name: 'ColumnName',
  components: {},
  filters: {},
  props: {
    enName: {
      type: String,
      default: ''
    },

    cnName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    };
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {
  }
};
</script>
<style lang='less' scoped>
.column-name {
  height: 258px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  .column-en {
    line-height: 1.1;
    font-size: 20px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 36px;
  }
  .column-cn {
    line-height: 1.1;
    font-size: 100px;
    color: #fff;
    font-weight: 700;
  }
}
</style>
